import { requiredParams } from "util/util";
import { handleApiError } from "./utils/handleApiError";

const getDataByCoql = async ({ accessToken = requiredParams("accessToken"), select_query = requiredParams("select_query") }) => {
  try {
    // const select_query =
    //   "SELECT Fax,Account_Name,Phone,Custom_Date_Time_1,Custom_Date_Time_2,Parent_Account,Owner.profile.name,Owner.id  from Accounts where (Custom_Date_Time_1 >= '2025-10-01T00:00:00+00:00' AND Custom_Date_Time_2 <= '2025-10-31T23:59:59+00:00')";
    const query = { select_query };

    const req_data = {
      url: "https://www.zohoapis.com/crm/v8/coql",
      type: "POST",
      body: JSON.stringify(query),
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };

    const resp = await window.ZOHO.CRM.HTTP.post(req_data);
    let data = JSON.parse(resp || "{}")?.data || [];
    return { data, error: null };
  } catch (error) {
    return {
      data: null,
      error: handleApiError("getDataByCoql", error),
    };
  }
};
export const coql = { getDataByCoql };
